import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import $ from 'jquery'
import { getToken } from './utils/auth'

NProgress.configure({
    showSpinner: false
})

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = getToken()
    if (hasToken) { // 存在token
        const userInfo = store.getters.userInfo
        const userInfoFlag = $.isEmptyObject(userInfo)
        let superAdmin = ''
        if (!userInfoFlag) {
            superAdmin = userInfo.roles && userInfo.roles.findIndex((item) => (item.roleName === '超级管理员'))
        }
        if (to.path === '/') {
            // await store.dispatch('user/resetToken')
            if (superAdmin === -1) {
                next('/counsel/consultingReply')
            } else {
                next('/hospital/hospitalList')
            }
            store.dispatch('user/ChooseHospital', 'doctor')
            NProgress.done()
        } else {
            // 用户信息iuid是否存在
            // 存在则不需要加载用户信息
            if (userInfo.iuid) {
                const dicFlag = $.isEmptyObject(store.getters.dictionary) // 判断字典项对象是否存在
                if (dicFlag) { // 不存在则加载字典项
                    await store.dispatch('user/GetDictionary')
                }
                if (!to.meta.allCanVisit && superAdmin === -1) {
                    if (from.path === '/') {
                        await store.dispatch('user/resetToken')
                        next('/login')
                    } else {
                        // next(from.path)
                        next()
                    }
                } else {
                    next()
                }
                NProgress.done()
            } else { // 不存在用户信息，则重新加载用户信息
                try {
                    await store.dispatch('user/getInfo') // 加载用户信息
                    await store.dispatch('user/GetDictionary') // 加载字典项信息
                    next({ ...to, replace: true })
                } catch (error) {
                    await store.dispatch('user/resetToken') // 重置路由信息
                    next('/login')
                    NProgress.done()
                }
            }
        }
    } else { // 不存在token，是否在whiteList里面，不在跳转到登录页面
        if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('/videoShow') !== -1) {
            next()
        } else {
            next('/login')
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
